import React from 'react';

import { SpaceHeaderStyles } from '../../../../app/spaces/Header/SpaceHeaderStyles';
import { Formatters, Messages } from '../../../../codegen/Localize';

export interface FavoriteToggleTooltipContentProps {
  readonly favoritesCount: number;
  readonly isFavorite: boolean;
}

export function FavoriteToggleTooltipContent(props: FavoriteToggleTooltipContentProps) {
  return (
    <div className={SpaceHeaderStyles.FavoriteTooltip}>
      {getContentText(props)}
    </div>
  );
}

function getContentText(props: FavoriteToggleTooltipContentProps) {
  const favoritesCount = props.favoritesCount || 0;
  const shouldShowCounts = props.isFavorite ? (props.favoritesCount > 1) : (props.favoritesCount > 0);

  if (shouldShowCounts) {
    return Messages.favoritedByTooltip({
      USER_COUNT: favoritesCount,
      USER_COUNT_LOC: Formatters.formatCount(favoritesCount)
    });
  } else {
    return props.isFavorite? Messages.favoritesTitleNotFavorited() : Messages.favoritesTitleFavorited();
  }
}
